module.exports = __webpack_public_path__ + "static/img/图层 584.8a2bd45a.png";